import { Component, OnDestroy, OnInit, inject, input } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { IImage, IPrismicImage } from '../../_models/prismic/prismic-image.model';
import { Subject, takeUntil } from 'rxjs';
import { EXTRA_LARGE_BREAKPOINT, EXTRA_SMALL_BREAKPOINT, LARGE_BREAKPOINT, MEDIUM_BREAKPOINT, SMALL_BREAKPOINT } from '../../_constants/breakpoints';

@Component({
    selector: 'app-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.scss']
})
export class ImageComponent implements OnInit, OnDestroy {
  private readonly breakpointObserver = inject(BreakpointObserver);

  readonly prismicImage = input.required<IPrismicImage>();
  readonly objectFitCover = input(true);
  readonly bcimage = input(false);
  readonly overlap = input(false);
  readonly desktopOverlap = input(false);

  public imageToDisplay!: IImage;

  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  ngOnInit(): void {
    const prismicImage = this.prismicImage();
    if (prismicImage.mobile || prismicImage.tablet) {
      this.breakpointObserver.observe([
        EXTRA_SMALL_BREAKPOINT,
        SMALL_BREAKPOINT,
        MEDIUM_BREAKPOINT,
        LARGE_BREAKPOINT,
        EXTRA_LARGE_BREAKPOINT
      ]).pipe(takeUntil(this.unsubscribe))
        .subscribe((state: BreakpointState) => {
          if (state.breakpoints[LARGE_BREAKPOINT]) {
            const prismicImageValue = this.prismicImage();
            this.imageToDisplay = prismicImageValue.desktop ?? prismicImageValue.laptop ?? prismicImageValue.tablet ?? prismicImageValue.mobile;
          } else if (state.breakpoints[MEDIUM_BREAKPOINT]) {
            const prismicImageValue = this.prismicImage();
            this.imageToDisplay = prismicImageValue.laptop ?? prismicImageValue.tablet ?? prismicImageValue.mobile;
          } else if (state.breakpoints[SMALL_BREAKPOINT]) {
            const prismicImageValue = this.prismicImage();
            this.imageToDisplay = prismicImageValue.tablet ?? prismicImageValue.mobile;
          } else if (state.breakpoints[EXTRA_SMALL_BREAKPOINT]) {
            this.imageToDisplay = this.prismicImage().mobile;
          } else {
            this.imageToDisplay = {
              alt: this.prismicImage().alt,
              dimensions: this.prismicImage().dimensions,
              url: this.prismicImage().url
            }
          }

          if (!this.imageToDisplay) {
            this.imageToDisplay = {
              alt: this.prismicImage().alt,
              dimensions: this.prismicImage().dimensions,
              url: this.prismicImage().url
            }
          }
        });
    } else {
      this.imageToDisplay = {
        alt: prismicImage.alt,
        dimensions: prismicImage.dimensions,
        url: prismicImage.url
      }
    }
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
